/** 设计稿基础宽度：px */
export const VM_BASE_WIDTH = 375;

/** 样式单位转换：px -> vw */
export const styleNumPxToVm = ($px?: number): number | '' => (typeof $px === 'number' ? ($px / VM_BASE_WIDTH) * 100 : '');

/** 样式单位转换：vw -> px */
export const styleNumVmToPx = ($vm: number): number => ($vm * VM_BASE_WIDTH) / 100;

/** 样式对象转换：px -> vw */
export const styleRecordPxToVm = (originStyle?: Record<string, string>): Record<string, string> => {
  if (!originStyle) {
    return {};
  }

  const lastStyle = {} as Record<string, string>;

  Object.keys(originStyle).forEach((key: string) => {
    const val = originStyle[key];

    /** 自定义style样式，单位px -> vw */
    if (String(val).includes('px')) {
      lastStyle[key] = `${styleNumPxToVm(Number(val.replace('px', '')))}vw`;
    } else {
      lastStyle[key] = val;
    }
  });

  return lastStyle;
};
